import { HttpContextToken } from '@angular/common/http';

export const USE_OTP_API = new HttpContextToken<boolean>(() => false);
export const SUPPRESS_ERROR_TOAST = new HttpContextToken<boolean>(() => false);
